const $retailOrderTable = $('.js-retail-order');
const $retailOrderTableResult = $('.js-table-result');

if ($retailOrderTable.length && $retailOrderTable.data('customer-id') && $retailOrderTable.data('api')) {
  const customerID = $retailOrderTable.data('customer-id');
  const customerHash = $retailOrderTable.data('hash');
  const customerApi = $retailOrderTable.data('api');
  const tableTemplateItems = $('#js-table-items').html(); // whole table
  const tableTemplateItem = $('#js-table-item').html(); // item

  const payload = {
    "customer": customerID,
    "h": customerHash
  };

  const buildTable = (data) => {
    let html = '';

    data.forEach(order => {
      let newOrder = tableTemplateItems;
      newOrder = newOrder.replace(/placeholderOrderNumber/g, order.orderNumber);
      newOrder = newOrder.replace(/placeholderDate/g, order.orderDateTime);
      newOrder = newOrder.replace(/placeholderName/g, order.storeName);

      let orderItems = '';
      order.orderLines.forEach(orderLine => {
        let newOrderItem = tableTemplateItem;
        
        newOrderItem = newOrderItem.replace(/placeholderItemDescription/g, orderLine.ProductDesc);
        newOrderItem = newOrderItem.replace(/placeholderItemProductId/g, orderLine.Product);
        newOrderItem = newOrderItem.replace(/placeholderItemSize/g, (orderLine.PrntCode2 ? orderLine.PrntCode2 : '-'));
        newOrderItem = newOrderItem.replace(/placeholderItemFit/g, (orderLine.MtrxCode1 ? orderLine.MtrxCode1 : '-'));
        newOrderItem = newOrderItem.replace(/placeholderItemQuantity/g, orderLine.Quantity);

        orderItems += newOrderItem;
      })

      newOrder = newOrder.replace(/placeholderOrderItems/g, orderItems);
      
      html = html + newOrder;
    })

    return html;
  }

  $.post(customerApi, payload, function(data, status) {
    if (status == 'success' && data.length > 0 && data !== 'Bad request') {
      $retailOrderTable.find('.js-table-result').html(buildTable(data))
      $retailOrderTable.toggleClass('is-loaded');

      $retailOrderTableResult.find('.retail-order-table__row-inner').each(function() {
        const $this = $(this);

        $this.on('click', function() {
          const $this = $(this);
          const $currentRow = $this.closest('.retail-order-table__row');
          $currentRow.find('.retail-order-table__order').slideToggle();
          $currentRow.toggleClass('is-active');
        })
      })

      return;
    }
  })
  .fail(function(xhr, status, error) {
    $retailOrderTable.toggleClass('is-loaded');
    $retailOrderTable.addClass('is-empty');
  });
} else if ($retailOrderTable.length) {
  $retailOrderTable.toggleClass('is-loaded');
  $retailOrderTable.addClass('is-empty');
}
